<template>
  <div class="flexChart">
    <div class="chartContent">
      <div class="content">
        Tage, an denen mind. <span class="pie3">30&nbsp;%</span>, <span class="pie2">50&nbsp;%</span> oder
        <span class="pie1">80&nbsp;%</span> Ökostrom seit Anfang 2025 erreicht wurden.
      </div>
    </div>
    <div class="chartContainer" ref="chartContainer">
      <div ref="chart" class="lineChart"></div>
      <div class="tooltip tooltip4"></div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";

export default {
  props: {
    dataElecAverage: {
      type: Array,
      required: true,
    },
    dataElecAverageBig: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleResize: _.debounce(function () {
      this.windowWidth = window.innerWidth;
      const chartParent = this.$refs.chart;
      const svgNode = chartParent.querySelector("svg");
      chartParent.removeChild(svgNode);
      this.drawChart(this.$refs.chartContainer.clientWidth);
    }, 200),
    drawChart(containerWidth) {
      const chartWidth = containerWidth;
      //console.log("drawChart elecAverage", console.log(JSON.stringify(this.dataElecAverage)));
      const data2 = this.dataElecAverage;
      const data4 = data2.flatMap((arr) => {
        return arr.map((value, index) => {
          return { value, key: `Segment ${index + 1}` };
        });
      });
      //let data = data4.reverse();
      let data = data4;

      // explain data:
      // data[0]: 0 > 30
      // data[1]: 30 > 50
      // data[2]: 50 > 80
      // data[3]: > 80

      const colors = ["var(--mm-green-pie3)", "var(--mm-green-pie2)", "var(--mm-green-pie1)", "var(--mm-grey-700)"];
      const tooltipText = [
        " mit<br />30 % – 49&nbsp;%",
        " mit<br />50 % – 79&nbsp;%",
        " mit<br />mind. 80&nbsp;%",
        " mit<br />bis zu 29&nbsp;%",
      ];

      //console.log(JSON.stringify(data));
      // let data = [
      //   { value: 53, key: "Segment 2" },
      //   { value: 8, key: "Segment 1" },
      // ];
      const margin = { top: 5, right: 0, bottom: 1, left: 16 };
      const width = chartWidth - margin.left - margin.right;
      const height = 96 - margin.top - margin.bottom;
      const radius = Math.min(width - 3, height - 3) / 2;

      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", `translate(${(width + 10) / 2},${height / 2 + margin.top})`);

      const color = d3.scaleOrdinal().range(colors);

      //const pie = d3.pie().value((d) => d.value);
      const pie = d3
        .pie()
        .sort(null)
        .value((d) => d.value);

      const arc = d3
        .arc()
        .innerRadius(radius * 0.6)
        .outerRadius(radius);

      const pie_sector = svg
        .selectAll("path")
        .data(pie(data))
        .enter()
        .append("path")
        .attr("d", arc)
        .attr("fill", (d, i) => color(i))
        .each(function (d) {
          let x_position = 0;
          let color = "";
          color = colors[d.index];
          if (d.index === 0) {
            x_position = 30;
          } else if (d.index === 1) {
            x_position = -45;
          } else if (d.index === 2) {
            x_position = -30;
          } else {
            color = "transparent";
            x_position = -10000;
          }
          const centroid = arc.centroid(d);
          const x = centroid[0];
          const y = centroid[1];
          const label = d.data.key;
          const value = d.data.value;
          svg
            .append("text")
            .attr("text-anchor", "middle")
            .attr("x", x + x_position)
            .attr("class", "axis-label")
            .attr("y", y + 4)
            .attr("fill", color)
            .text(value);
        })
        .attr("class", "mask")
        .style("cursor", "pointer")
        .on("mouseover", () => {})
        .on("touchmove mousemove", (event, d) => {
          const containerOffset = pie_sector.node().getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const tooltip = d3.select(".tooltip4");
          tooltip.transition().duration(200).style("opacity", 0.9);
          tooltip
            .html(
              "<span style='font-weight: bold; color:" +
                colors[d.index] +
                "'>" +
                d.value +
                " Tage</span>" +
                tooltipText[d.index]
            )
            .style("left", function () {
              const svgOffset = svg.node().getBoundingClientRect();
              const current_position = event.pageX - containerOffset.left;
              if (current_position > 0) {
                var pos = event.pageX + 120 - containerOffset.left;
                if (current_position + chartWidth / 2 > chartWidth - 100) {
                  pos = chartWidth - 100;
                }
                return pos + "px";
              } else {
                return event.pageX - 30 + 50 - containerOffset.left + "px";
              }
            })
            .style("top", function () {
              const svgOffset = svg.node().getBoundingClientRect();
              const current_position = event.pageY - containerOffset.top - scrollTop;
              // trim edge cases
              if (current_position - 30 < 0) {
                return 20 + "px";
              } else if (current_position + 10 > svgOffset.height) {
                return svgOffset.height - 15 + "px";
              } else {
                return current_position + "px";
              }
            })
            .style("cursor", "pointer");
        })
        .on("mouseout", () => {
          d3.select(".tooltip4").transition().duration(500).style("opacity", 0);
        });
      // .transition() // remove animation
      // .duration(1000)
      // .attrTween("d", function (d) {
      //   var i = d3.interpolate(d.startAngle, d.endAngle);
      //   return function (t) {
      //     d.endAngle = i(t);
      //     return arc(d);
      //};
      //});

      // const sum = data.reduce((acc, d) => acc + d.value, 0);

      // svg
      //   .append("text")
      //   .attr("text-anchor", "middle")
      //   .attr("class", "axis-label")
      //   .text(sum)
      //   .attr("x", 0)
      //   .attr("y", 0 + 4);
    },
  },
  watch: {
    dataElecAverage() {
      let chartWidth = this.$refs.chartContainer.clientWidth;
      this.drawChart(chartWidth);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
